import { useState } from "react";
import SectionTitle from "./SectionTitle";
import { downloadDevices } from "@/mocks/home";

export default function Download() {
  const [active, setActive] = useState(downloadDevices[0].id);
  const current = downloadDevices.find((d) => d.id === active) ?? downloadDevices[0];

  return (
    <section id="download" className="bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="下载方式"
          title="下载之后不知道放哪、拿什么打开？"
          desc="按你使用的设备选择查看，每一步都写清楚了文件位置和打开方式。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-10">
          <div className="lg:col-span-3">
            <div className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-100 border border-background-200">
              {downloadDevices.map((d) => {
                const isActive = active === d.id;
                return (
                  <button
                    key={d.id}
                    type="button"
                    onClick={() => setActive(d.id)}
                    aria-pressed={isActive}
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-700 hover:bg-background-200"
                    }`}
                  >
                    <i className={d.icon} aria-hidden="true"></i>
                    {d.label}
                  </button>
                );
              })}
            </div>

            <ol className="mt-6 space-y-4">
              {current.steps.map((step, idx) => (
                <li key={step} className="flex gap-4">
                  <span className="shrink-0 w-8 h-8 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-sm font-semibold">
                    {idx + 1}
                  </span>
                  <p className="pt-1 text-sm text-foreground-700 leading-relaxed">{step}</p>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex flex-wrap gap-3">
              {current.notes.map((n) => (
                <span
                  key={n}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-xs"
                >
                  <i className="ri-information-line" aria-hidden="true"></i>
                  {n}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20smartphone%20laptop%20and%20tv%20box%20connected%20together%2C%20download%20arrow%20and%20play%20icons%2C%20green%20and%20warm%20red%20tones%2C%20clean%20minimal%20vector%20style%2C%20soft%20cream%20background%2C%20organized%20composition&width=1200&height=900&seq=wm-download-guide&orientation=landscape"
                alt="手机、电脑与电视盒子下载播放示意图"
                className="w-full h-full object-top"
              />
            </div>
            <p className="mt-3 text-xs text-foreground-600 leading-relaxed">
              下载前先确认存储空间，并在下载完成前不要切换网络，避免文件损坏导致无法打开。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}